import axios from "./common.js";
import { officialId, $encrypt, testR } from "./common.js";
/* axios.defaults.baseURL = "https://test-api.hakspay.cn/";
axios.defaults.headers.post["Content-Type"] = "application/json"; */
import { Message } from "element-ui";

/**
 * 获取二维码的地址
 * wxHelper/v2/common/PermissionUrl
 * @returns 
 */
export const PermissionUrl = function () {
  return axios.get("wxHelper/v2/common/PermissionUrl?appid=" + officialId);
};

//已经取消改接口 获取二维码图片
///common/v2/GetQrCode
/* export const GetQrCodeUrl = function(url) {
  return axios({
    url: `common/v2/GetQrCode?`,
    method: "get",
    params: {
      text: url
    }
  });
}; */

//获取用户登录的临时code
//wxHelper/v2/common/GetUserCode
export const GetUserCode = function (token) {
  return axios.get(`wxHelper/v2/common/GetUserCode?access_token=${token}`);
};

//通过临时code 获取用户信息
//https://test-api.hakspay.cn/v2/ePlatform/Service/wxChannel/UserCodeToUnionID
export const UserCodeToUnionID = function (code) {
  // console.log("",code);
  return axios.get(
    `/wxHelper/v2/common/UserCodeToAccessToken?appid=${officialId}&code=${code}&code_type=offiaccount`
  );
};

//使用令牌获取用户信息
//https://test-api.hakspay.cn/v2/ePlatform/Service/wxChannel/UserTokenToUserInfo
export const UserTokenToUserInfo = function (access_token, open_id) {
  return axios({
    url: `wxHelper/v2/common/UserTokenToUserInfo?`,
    method: "get",
    params: {
      access_token,
      open_id
    }
  });
};

//服务商登录
//https://test-api.hakspay.cn/v2/ePlatform/Service/ServiceProvider/login
export const ServiceProviderLogin = function (data) {
  return axios.post("ServiceProvider/v2/login", data).catch(err => {
    Message.error(err);
  });
};

//https://test-api.hakspay.cn/v2/ePlatform/Service/Membership/Account/register
/**
 * 用户、会员注册
 * Membership/v2/Account/register
 * @param {*} data
 * @returns
 */
export const accountRegister = function (data) {
  return axios.post("Membership/v2/Account/register", data).catch(err => {
    Message.error(err);
  });
};

/**发送短信
 * @param {Object} mobile_no
 */
export const sendMsg = function (mobile_no) {
  return axios.get("common/v2/sms/verifycode?mobile_no=" + mobile_no);
};

/**用户登录
 * Membership/v2/Account/login
 * @param {*} data
 * @returns
 */
export const accountLogin = async function (data) {
  try {
    return await axios.post("Membership/v2/Account/login", data);
  } catch (err) {
    Message.error(err);
  }
};

/**给用户授权的服务商列表
 * ServiceProvider/v2/permission/account/listServiceProvider
 * @returns
 */
export const getlistServiceProvider = async function () {
  try {
    return await axios.post(
      "ServiceProvider/v2/permission/account/listServiceProvider",
      {
        access_token: localStorage.getItem("access_token")
      }
    );
  } catch (err) {
    Message.error(err);
  }
};

//TODO: 接口报错 系统异常:对象名 'user_scope' 无效。
/**获取用户可以管理的店铺
 * Merchant/v2/permission/account/listMerchant
 */
export const getListMerchant = function () {
  return axios
    .post("Merchant/v2/permission/account/listMerchant", {
      access_token: localStorage.getItem("access_token")
    })
    .catch(err => {
      Message.error(err);
    });
};

/**
 * 公众号APPID生成带参数的二维码
 * https://test-api.hakspay.cn/v2/ePlatform/Service/wxChannel/GenerateParaetermQr
 * @returns 
 */
export const GenerateParaetermQr = function () {
  return axios({
    url: `v2/ePlatform/Service/wxChannel/GenerateParaetermQr`,
    method: "get",
    params: {
      appid: officialId,
      action_name: "QR_SCENE",
      expire_seconds: ""
    }
  });
};

//店铺登录
//Merchant/v2/login
/**
 * 店铺登录接口
 * @param {Object} data 
 * @returns 
 */
export const merchantLogin = function (data) {
  return axios.post("Merchant/v2/common/login", data).catch(err => {
    Message.error(err);
  });
  appidapp;
};

//wxHelper/v2/common/GenerateAccessTokenUrl
/**
 * 获取微信web网页授权登录CODE
 * method get
 * @returns {Promise<Object>} {
 *  code: "f1af1bde3b3e4d09a150b32b1c963c57";
 *  expire_seconds: 300;/
 *  ticket: "gQHb7zwAAAAAAAAAAS5odHRwOi8vd2VpeGluLnFxLmNvbS9xLzAyZ2Vxa3dOVm5mdkYxVnNUNk5EY0IAAgQwtsZnAwQsAQAA";
 *  url: "http://weixin.qq.com/q/02geqkwNVnfvF1VsT6NDcB";
 * }
 *
 */
export const generateAccessTokenUrl = function () {
  return axios({
    url: `/wxhelper/v2/login/GetLoginQr?appid=wx59275b1f7f83e45f`,
    method: "get"
  })
  /*  const url = `wxHelper/v2/common/GenerateAccessTokenUrl?appid=${officialId}`;
  return axios({
    url: "wxHelper/v2/common/GenerateAccessTokenUrl?appid=wx59275b1f7f83e45f",
    method: "get"
  });*/


};

/**
 *
 */
/* export const wxTicketUrl = function(ticket){
  return axios.get(`https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=${ticket}`)
} */

/**
 * 获取令牌接口
 */
export const getToken = async function () {

  const pass_word = await $encrypt(
    localStorage.getItem("pass_word"),
    "pass_word"
  );
  /* setTimeout(() => {
    console.log("这里啦啦啦啦啦啦啦啦啦啦啦啦啦啦啦啦啦啦啦")
    localStorage.setItem("expire_time", "2025-03-13 19:38:25");
  },1500) */
  switch (localStorage.getItem("token_type")) {
    case "account":
      if (
        localStorage.getItem("gettoken_type") &&
        localStorage.getItem("gettoken_type") == "scan"
      ) {
        window.showQrCode(true);
        //扫码登录
      } else if (!localStorage.getItem("gettoken_type")) {
        var obj = {
          account_type: "account_id",
          account_id: localStorage.getItem("account_id"),
          pass_word
        };
        const account_login = await accountLogin(obj);
        if (testR(account_login)) {
          setToken(
            account_login.data.resp_data.access_token,
            account_login.data.resp_data.expire_time
          );
        }
      }
      break;
    case "service":
      console.log("获取令牌");
      var obj = {
        service_no: localStorage.getItem("service_no"),
        pass_word
      };
      const serverlogin_res = await ServiceProviderLogin(obj);
      console.log("服务商登录res", serverlogin_res);
      if (testR(serverlogin_res)) {
        setToken(
          serverlogin_res.data.resp_data.access_token,
          serverlogin_res.data.resp_data.expire_time
        );
      }
      break;
    case "merchant":
      var obj = {
        merchant_id: localStorage.getItem("merchant_id"),
        pass_word
      };
      const merchantlogin_res = await merchantLogin(obj);
      if (testR(merchantlogin_res)) {
        setToken(
          merchantlogin_res.data.resp_data.access_token,
          merchantlogin_res.data.resp_data.expire_time
        );
      }
      break;
  }


};


const setToken = function (access_token, expire_time) {
  localStorage.setItem("access_token", access_token);
  localStorage.setItem("expire_time", expire_time);
};
